import LoanOriginationMemoPage from "components/Financial/LoanOriginationMemoPage";
import LoanBookListWorkspace from "components/Lender/LoanBook/LoanBookListWorkspace";
import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";

export const lenderRoutes = [
  {
    path: "/lender/loan_book",
    element: <RouteLayout />,
    children: [{ index: true, element: <LoanBookListWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Loan Book" />,
  },
  {
    path: "/lender/loan_origination_memo/",
    element: <RouteLayout />,
    children: [{ index: true, element: <LoanOriginationMemoPage /> }],
    errorElement: <RouteErrorLayout errorTitle="Loan Origination Memo" />,
  },
  {
    path: "/lender/loan_book/loan_origination_memo/:producer_token/:year/",
    element: <RouteLayout />,
    children: [{ index: true, element: <LoanOriginationMemoPage /> }],
    errorElement: <RouteErrorLayout errorTitle="Loan Origination Memo" />,
  },
];
